"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedTaxRateUpdateRequest = exports.mockedTaxRateCreateRequest = exports.mockedTaxRateResponse = exports.mockedTaxRateHistory = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const country_1 = require("../country");
const legal_entity_1 = require("../legal-entity");
exports.mockedTaxRateHistory = [{
  id: 1,
  createdAt: new Date(),
  updatedAt: null,
  validFrom: new Date(),
  rate: 10
}, {
  id: 2,
  createdAt: new Date('2010-01-01'),
  updatedAt: null,
  validFrom: new Date('2010-01-01'),
  rate: 20
}, {
  id: 3,
  createdAt: new Date('2015-07-01'),
  updatedAt: null,
  validFrom: new Date('2015-07-01'),
  rate: 30
}];
exports.mockedTaxRateResponse = {
  id: 1,
  country: country_1.mockedCountryResponse,
  name: 'Tax name',
  createdAt: new Date(),
  updatedAt: null,
  type: common_interfaces_1.TaxRateType.INCLUDED,
  legalEntity: legal_entity_1.mockedLegalEntityResponse,
  history: exports.mockedTaxRateHistory
};
exports.mockedTaxRateCreateRequest = {
  countryId: country_1.mockedCountryResponse.id,
  name: 'New tax name',
  rate: 12,
  validFrom: new Date(),
  type: common_interfaces_1.TaxRateType.EXCLUDED,
  legalEntityId: legal_entity_1.mockedLegalEntityResponse.id
};
exports.mockedTaxRateUpdateRequest = {
  countryId: country_1.mockedCountryResponse.id,
  name: 'Updated tax name',
  type: common_interfaces_1.TaxRateType.EXCLUDED,
  legalEntityId: legal_entity_1.mockedLegalEntityResponse.id,
  history: [{
    rate: 10,
    validFrom: new Date()
  }]
};